import React from 'react'
import { SignedIn, SignedOut, SignInButton, UserButton, useUser } from '@clerk/clerk-react'
import InventoryManagement from '../components/InventoryManagement'
import './AdminPage.css'

const AdminPage: React.FC = () => {
  // Check if Clerk is available
  const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
  
  // If Clerk is not configured, show a message
  if (!PUBLISHABLE_KEY) {
    return (
      <div className="admin-page">
        <div className="admin-signin">
          <div className="signin-card">
            <h1>Inventory Management</h1>
            <p>Authentication is not configured. Admin functionality is disabled.</p>
            <p>To enable admin features, please configure Clerk authentication.</p>
            <a href="/" className="home-link">← Back to Home</a>
          </div>
        </div>
      </div>
    )
  }

  const { user } = useUser()

  return (
    <div className="admin-page">
      <SignedOut>
        <div className="admin-signin">
          <div className="signin-card">
            <h1>Inventory Management</h1>
            <p>Please sign in to access inventory management</p>
            <SignInButton mode="modal">
              <button className="signin-btn">Sign In</button>
            </SignInButton>
          </div>
        </div>
      </SignedOut>

      <SignedIn>
        <div className="admin-dashboard">
          <header className="admin-header">
            <div className="admin-header-content">
              <h1>Trailer Inventory Management</h1>
              <div className="admin-user">
                <span>Welcome, {user?.firstName || user?.emailAddresses[0]?.emailAddress}</span>
                <UserButton afterSignOutUrl="/" />
              </div>
            </div>
          </header>

          <div className="admin-content-simple">
            <InventoryManagement onClose={() => {}} />
          </div>
        </div>
      </SignedIn>
    </div>
  )
}

export default AdminPage